import { makeActionCreator } from '../redux-util/general-helpers';
import { TOGGLE_ASSET_STATUS, TOGGLE_STRING_DEBUG } from './dev-keys';
import { setCookie, getCookie } from '../../utils/cookie';
import { pointingToProd } from './dev-selectors';
import { loadScripts } from '../../utils/dom';
import { isDevOrLocal } from '../../utils/env';

export const toggleStringDebug = makeActionCreator(TOGGLE_STRING_DEBUG);
export const toggleAssetStatus = makeActionCreator(TOGGLE_ASSET_STATUS);

function setCookieAndReload(newVal) {
  setCookie('productionJigsaw', newVal, 2);

  const interval = window.setInterval(() => {
    const val = getCookie('productionJigsaw');
    if (`${val}` === `${newVal}`) {
      window.clearInterval(interval);
      window.location.reload();
    }
  }, 200);
}

export function pointToProd() {
  return function() {
    setCookieAndReload('true');
  };
}

export function pointToDev() {
  return function() {
    setCookieAndReload('false');
  };
}

export function tryLoadProdServices() {
  return function(dispatch) {
    if (pointingToProd() && isDevOrLocal()) {
      window.jigsawLoadError = false;
      window.bridgeLoadError = false;
      const cacheBust = `?v=${new Date().valueOf()}`;
      return loadScripts(
        `//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js${cacheBust}`,
        `//services.vstbridge.com/assets/v1/bridge.js${cacheBust}`
      ).catch(() => dispatch(pointToDev()));
    }
    return Promise.resolve();
  };
}
